import axios from 'axios';
let client = null;
let lastBaseUrl = null;
let accessTokenGetter = null;
export const setWalletHttpAccessTokenGetter = (getter) => {
    accessTokenGetter = getter;
};
const createClient = (baseURL) => {
    const instance = axios.create({ baseURL, withCredentials: false });
    instance.interceptors.request.use(config => {
        const token = accessTokenGetter?.() ??
            (typeof window !== 'undefined' ? window.__CMS_MFE_GET_WALLET_ACCESS_TOKEN__?.() ?? null : null);
        if (token != null && String(token).length > 0) {
            const clean = String(token).replace(/^"|"$/g, '');
            config.headers.Authorization = `Bearer ${clean}`;
        }
        return config;
    });
    return instance;
};
export const setWalletHttpBaseUrl = (baseUrl) => {
    const b = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    if (client && lastBaseUrl === b) {
        return;
    }
    lastBaseUrl = b;
    client = createClient(b);
};
export const walletHttp = () => {
    if (!client) {
        client = createClient();
    }
    return client;
};
